<template>
  <div class="rsf-google-map flex-grow" ref="map" style="width: 100%; height: 100%"></div>
</template>

<script>
import { EventBus } from "@/event-bus";
import { customInfoWindowLogic } from "../assets/scripts/customInfoWindowLogic.js";
import { customInfoWindowConstruction } from "@/assets/scripts/customInfoWindow.js";

export default {
  name: "GoogleMaps",
  props: {
    center: Object,
    zoom: Number,
    userPosition: Object,
    unit: String,
  },
  data() {
    return {
      map: null,
      apiLoaded: false,
      AdvancedMarkerElement: null,
      markers: [],
      positionMarkerPosition: null,
      infoWindow: null,
      circle: null,
      placeInput: null,
    };
  },
  created() {
    EventBus.$on("load_markers", (markers) => {
      if (!this.apiLoaded) {
        return;
      }
      this.loadMarkers(markers);
    });
    EventBus.$on("clear_single_marker", (index) => {
      this.clearSingleMarker(index);
    });
    EventBus.$on("clear_all_markers", () => {
      this.clearAllMarkers();
    });
    EventBus.$on("go_to_point", (position) => {
      // this.addPositionMarker(position);
    });
    EventBus.$on("draw_circle", (payload) => {
      this.addCircle(payload.position, payload.radius);
    });
    EventBus.$on("highlight_marker", (payload) => {
      this.escapeStreetView();
      this.highlightMarker(payload.position, payload.store);
    });
    EventBus.$on("add_streetview_panorama", (position) => {
      this.addStreetViewPanorama(position);
    });
    EventBus.$on("escape_street_view", () => {
      this.escapeStreetView();
    });
    EventBus.$on("add_info_window", (payload) => {
      this.addInfoWindow(payload.position, payload.store);
    });
    EventBus.$on("dehighlight_marker", () => {
      this.dehighlightAllMarkers();
    });
    EventBus.$on("close_info_window", () => {
      if (!this.infoWindow) {
        return;
      }
      this.infoWindow.close();
    });
    EventBus.$on("escape_streetview", () => {
      this.escapeStreetView();
    });
    EventBus.$on("determine_country", (position) => {
      this.determineCountry(position);
    });
  },
  mounted() {
    this.loadGoogleMapsAPI()
      .then(() => {
        this.apiLoaded = true;
        this.initMap();
      })
      .catch((error) => {
        console.error("Failed to load Google Maps API:", error);
      });
  },
  methods: {
    loadGoogleMapsAPI() {
      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          resolve();
        } else {
          const script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA_0uSA-nGcR-zkkG8PWcjWtPC2eaeqhKw&callback=initGoogleMap&libraries=geometry,places,marker`;
          script.async = true;
          script.defer = true;
          script.onerror = reject;
          document.head.appendChild(script);

          // Expose initMap function globally for callback
          window.initGoogleMap = resolve;
        }
      });
    },
    async initPlacesLibrary() {
      try {
        // Initialize autocomplete
        const autocomplete = new google.maps.places.Autocomplete(this.$parent.$refs["address-input"]);
        const autocomplete2 = new google.maps.places.Autocomplete(this.$parent.$refs["address-input-mobile"]);
        autocomplete.bindTo("bounds", this.map);
        autocomplete2.bindTo("bounds", this.map);

        // Listen for place changes and center the map to the selected place
        autocomplete.addListener("place_changed", () => {
          let place = autocomplete.getPlace();
          EventBus.$emit("update_input_value", place);
        });
        // Listen for place changes and center the map to the selected place
        autocomplete2.addListener("place_changed", () => {
          let place = autocomplete2.getPlace();
          EventBus.$emit("update_input_value", place);
        });
      } catch (error) {
        console.error("Failed to initialize Places Library:", error);
      }
    },

    async initMap() {
      if (!this.apiLoaded) {
        console.error("Google Maps API not loaded");
        return;
      }

      // Set default center and zoom if not provided
      const mapOptions = {
        center: this.center || { lat: 0, lng: 0 },
        zoom: this.zoom || 8,
        mapId: "8e2c390688169e1b",
        mapTypeControl: false,
        streetViewControl: true,
        zoomControl: true,
        fullscreenControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT, // Set position for streetViewControl
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT, // Set position for zoomControl
        },
      };
      // Initialize Google Map
      this.map = new google.maps.Map(this.$refs.map, mapOptions);
      EventBus.$emit("google_maps_loaded");

      // Init infowindow
      // const infowindow = new google.maps.InfoWindow({
      //   content: '<div class="">This is a text my man</div>',
      //   ariaLabel: "Test",
      //   pixelOffset: new google.maps.Size(20, 0),
      // });
      // this.infoWindow = infowindow;

      // Load AdvancedMarkerElement
      try {
        const library = await google.maps.importLibrary("marker");
        this.AdvancedMarkerElement = library.AdvancedMarkerElement;

        // Add markers if provided
        // if (this.markers) {
        //   this.markers.forEach(marker => {
        //     this.addMarker(marker.position);
        //   });
        // }
      } catch (error) {
        console.error("Failed to load AdvancedMarkerElement:", error);
      }

      this.initPlacesLibrary();
    },
    addMarker(position) {
      const svgString = `<svg class="pin-width" style="transition: ease-in-out 0.2s;" width="30" height="100%" viewBox="0 0 74 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.5552 36.7673C73.5552 56.7874 36.9998 99.0097 36.9998 99.0097C36.9998 99.0097 0.444336 56.7874 0.444336 36.7673C0.444336 16.7473 16.8108 0.517822 36.9998 0.517822C57.1888 0.517822 73.5552 16.7473 73.5552 36.7673Z" fill="#FF3235"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.7626 24.2089C28.3973 24.2089 28.1014 23.9602 28.1014 23.6538C28.1014 23.3478 28.3973 23.0991 28.7626 23.0991C29.1279 23.0991 29.4238 23.3478 29.4238 23.6538C29.4238 23.9602 29.1279 24.2089 28.7626 24.2089ZM49.9796 47.7394C49.9796 47.7382 49.9801 47.737 49.9801 47.7359L49.9794 47.732C49.9794 45.849 48.4322 44.3171 46.5314 44.3171C44.6302 44.3171 43.0835 45.849 43.0835 47.732C43.0629 48.1441 43.2174 48.8288 43.408 49.1792C43.4089 49.1811 43.4087 49.1825 43.4087 49.1825C43.4105 49.1859 43.4122 49.1871 43.4131 49.1887C43.5848 49.5504 44.0235 49.7077 44.391 49.5389C44.7552 49.3689 44.912 48.9344 44.7395 48.5714L44.7389 48.5706C44.6259 48.347 44.5419 47.9691 44.5521 47.7235C44.5521 46.6493 45.4402 45.7689 46.5314 45.7689C47.6202 45.7689 48.5061 46.6455 48.5104 47.7244C48.5104 47.7249 48.5106 47.7253 48.5106 47.7253V47.7303V47.732L48.5104 47.7325C48.5633 49.6456 47.1393 51.492 45.2658 51.9378C44.8844 52.0408 44.496 52.0917 44.11 52.0917C43.3554 52.0917 42.6089 51.8971 41.9351 51.5147C40.92 50.9387 40.1917 50.0063 39.8825 48.8883C39.8825 48.8883 39.8823 48.8879 39.8821 48.8873C39.8814 48.885 39.8807 48.8822 39.8795 48.8798C39.8795 48.8798 39.8788 48.8771 39.8783 48.8758V48.8755C39.1349 46.6711 39.5038 43.262 40.702 41.2654L40.7024 41.2645C44.052 35.425 42.9609 26.7214 38.27 21.8634C38.2677 21.8608 38.2673 21.8572 38.2648 21.8549C38.2626 21.8526 38.2596 21.8514 38.2575 21.8491C36.7678 19.9776 33.9171 18.699 31.8737 18.6484C31.8718 18.6484 31.0685 18.6472 31.0665 18.6472L31.0669 18.6484H24.0176L25.1996 20.0235V34.9549L24.3439 35.8031H29.5315L28.7631 35.0409V31.0342C28.7631 31.0342 33.0188 31.893 33.0188 22.8858C33.5313 22.8858 35.3311 26.9483 33.2095 32.192C31.5144 36.1252 31.0658 42.0306 32.2806 45.8124C32.2819 45.8162 32.2809 45.8205 32.2819 45.8244C32.2828 45.8278 32.2854 45.8304 32.2862 45.8342C33.0566 49.6634 36.7874 53.575 40.6022 54.554C40.6043 54.5545 40.6052 54.5558 40.6052 54.5558C40.6088 54.5569 40.6103 54.5562 40.6103 54.5562C42.4497 55.1277 44.4018 54.9555 46.1087 54.0702C47.8151 53.1857 49.0725 51.6948 49.6482 49.872C49.8415 49.3427 50.001 48.3105 49.9796 47.7394Z" fill="white"/>
      </svg>`;
      let svgNode = this.createSVGElementFromSVGString(svgString);
      const marker = new this.AdvancedMarkerElement({
        position,
        map: this.map,
        content: svgNode,
      });
      marker.addListener("click", () => {
        this.escapeStreetView();
        EventBus.$emit("select_store", position);
        this.highlightMarker(marker.position);
      });
      this.markers.push(marker);
    },
    addPositionMarker(position) {
      this.positionMarkerPosition = position;
      const svgString = `<svg class="" width="38" height="52" viewBox="0 0 38 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M37.4111 19.0653C37.4111 29.3516 18.7861 51.0455 18.7861 51.0455C18.7861 51.0455 0.161133 29.3516 0.161133 19.0653C0.161133 8.779 8.49983 0.440308 18.7861 0.440308C29.0724 0.440308 37.4111 8.779 37.4111 19.0653Z" fill="#1867ff"/>
      <circle cx="18.7859" cy="17.5964" r="6.15216" fill="white"/>
      </svg>`;
      let svgNode = this.createSVGElementFromSVGString(svgString);
      const marker = new this.AdvancedMarkerElement({
        position,
        map: this.map,
        content: svgNode,
      });
      this.markers.push(marker);
      this.zoomToFitAllMarkers();
    },
    addCircle(position, radius) {
      if (this.circle != null) {
        this.circle.setMap(null);
      }
      const circle = new google.maps.Circle({
        strokeColor: "#0000FF",
        strokeOpacity: 0.5,
        strokeWeight: 2,
        fillColor: "#0000FF",
        fillOpacity: 0.075,
        map: this.map,
        center: { lat: position.lat, lng: position.lng },
        radius: radius * 1000,
        clickable: false,
      });
      this.circle = circle;
    },
    highlightMarker(position, store) {
      this.dehighlightAllMarkers();
      this.makeEveryNonHighlightedMarkersGray(position);
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].position.lat == position.lat && this.markers[i].position.lng == position.lng) {
          this.offsetCenter(new google.maps.LatLng(position.lat, position.lng), 145, this.map);
          this.map.panTo(position);
          const svgString = `<svg class="pin-width" style="transition: ease-in-out 0.2s;" width="30" height="100%" viewBox="0 0 74 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.5552 36.7673C73.5552 56.7874 36.9998 99.0097 36.9998 99.0097C36.9998 99.0097 0.444336 56.7874 0.444336 36.7673C0.444336 16.7473 16.8108 0.517822 36.9998 0.517822C57.1888 0.517822 73.5552 16.7473 73.5552 36.7673Z" fill="#FF3235"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.7626 24.2089C28.3973 24.2089 28.1014 23.9602 28.1014 23.6538C28.1014 23.3478 28.3973 23.0991 28.7626 23.0991C29.1279 23.0991 29.4238 23.3478 29.4238 23.6538C29.4238 23.9602 29.1279 24.2089 28.7626 24.2089ZM49.9796 47.7394C49.9796 47.7382 49.9801 47.737 49.9801 47.7359L49.9794 47.732C49.9794 45.849 48.4322 44.3171 46.5314 44.3171C44.6302 44.3171 43.0835 45.849 43.0835 47.732C43.0629 48.1441 43.2174 48.8288 43.408 49.1792C43.4089 49.1811 43.4087 49.1825 43.4087 49.1825C43.4105 49.1859 43.4122 49.1871 43.4131 49.1887C43.5848 49.5504 44.0235 49.7077 44.391 49.5389C44.7552 49.3689 44.912 48.9344 44.7395 48.5714L44.7389 48.5706C44.6259 48.347 44.5419 47.9691 44.5521 47.7235C44.5521 46.6493 45.4402 45.7689 46.5314 45.7689C47.6202 45.7689 48.5061 46.6455 48.5104 47.7244C48.5104 47.7249 48.5106 47.7253 48.5106 47.7253V47.7303V47.732L48.5104 47.7325C48.5633 49.6456 47.1393 51.492 45.2658 51.9378C44.8844 52.0408 44.496 52.0917 44.11 52.0917C43.3554 52.0917 42.6089 51.8971 41.9351 51.5147C40.92 50.9387 40.1917 50.0063 39.8825 48.8883C39.8825 48.8883 39.8823 48.8879 39.8821 48.8873C39.8814 48.885 39.8807 48.8822 39.8795 48.8798C39.8795 48.8798 39.8788 48.8771 39.8783 48.8758V48.8755C39.1349 46.6711 39.5038 43.262 40.702 41.2654L40.7024 41.2645C44.052 35.425 42.9609 26.7214 38.27 21.8634C38.2677 21.8608 38.2673 21.8572 38.2648 21.8549C38.2626 21.8526 38.2596 21.8514 38.2575 21.8491C36.7678 19.9776 33.9171 18.699 31.8737 18.6484C31.8718 18.6484 31.0685 18.6472 31.0665 18.6472L31.0669 18.6484H24.0176L25.1996 20.0235V34.9549L24.3439 35.8031H29.5315L28.7631 35.0409V31.0342C28.7631 31.0342 33.0188 31.893 33.0188 22.8858C33.5313 22.8858 35.3311 26.9483 33.2095 32.192C31.5144 36.1252 31.0658 42.0306 32.2806 45.8124C32.2819 45.8162 32.2809 45.8205 32.2819 45.8244C32.2828 45.8278 32.2854 45.8304 32.2862 45.8342C33.0566 49.6634 36.7874 53.575 40.6022 54.554C40.6043 54.5545 40.6052 54.5558 40.6052 54.5558C40.6088 54.5569 40.6103 54.5562 40.6103 54.5562C42.4497 55.1277 44.4018 54.9555 46.1087 54.0702C47.8151 53.1857 49.0725 51.6948 49.6482 49.872C49.8415 49.3427 50.001 48.3105 49.9796 47.7394Z" fill="white"/>
      </svg>`;
          let svgNode = this.createSVGElementFromSVGString(svgString);
          this.markers[i].content = svgNode;
          let bigIcon = this.markers[i].content;
          bigIcon.classList.add("pin-width-highlighted");
          this.markers[i].content = bigIcon;
          this.markers[i].zIndex = 10;

          return;
        }
      }
    },
    addInfoWindow(position, store) {
      // Custom InfoWindow class
      class CustomInfoWindow extends google.maps.OverlayView {
        constructor(content, position) {
          super();
          this.content = content;
          this.position = position;
          this.div = null;
        }

        onAdd() {
          this.div = document.createElement("div");
          this.div.innerHTML = this.content;
          this.div.style.position = "absolute";
          this.getPanes().floatPane.appendChild(this.div);
        }

        draw() {
          if (this.div) {
            const overlayProjection = this.getProjection();
            const positionPixel = overlayProjection.fromLatLngToDivPixel(this.position);

            this.div.style.left = `${positionPixel.x}px`;
            this.div.style.top = `${positionPixel.y}px`;
          }
        }

        onRemove() {
          if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
          }
        }

        setPosition(position) {
          this.position = position;
          if (this.div) {
            this.draw();
          }
        }

        setContent(content) {
          this.content = content;
          if (this.div) {
            this.div.innerHTML = content;
          }
        }

        open(map) {
          this.setMap(map);
        }

        close() {
          this.setMap(null);
        }
      }

      let translations = {
        storefinder_btn_label_email: this.$t("storefinder_btn_label_email"),
        storefinder_btn_label_website: this.$t("storefinder_btn_label_website"),
        storefinder_btn_label_phone: this.$t("storefinder_btn_label_phone"),
        storefinder_btn_label_get_directions: this.$t("storefinder_btn_label_get_directions"),
        storefinder_btn_label_street_view: this.$t("storefinder_btn_label_street_view"),
        storefinder_store_away: this.$t("storefinder_store_away"),
        storefinder_unit_kilometers: this.$t("storefinder_unit_kilometers"),
        storefinder_unit_miles: this.$t("storefinder_unit_miles"),
        storefinder_btn_label_video: this.$t("storefinder_btn_label_video"),
      };

      const content = customInfoWindowConstruction(store, this.userPosition, this.unit, translations);

      if (this.infoWindow) {
        this.infoWindow.close(); // Close previous InfoWindow if it exists
      }

      this.infoWindow = new CustomInfoWindow(content, position);
      let myInfoWindow = this.infoWindow;
      google.maps.event.addListener(myInfoWindow, "domready", function () {
        console.log("custom idnowindow domready");
      });
      this.infoWindow.open(this.map);
      setTimeout(() => {
        customInfoWindowLogic(store, this.map);
      }, 0);
    },
    makeEveryNonHighlightedMarkersGray(position) {
      // TODO: check if marker is position marker
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].position.lat == position.lat && this.markers[i].position.lng == position.lng) {
          continue;
        } else {
          const svgString = `<svg class="pin-width" style="transition: ease-in-out 0.2s;" width="30" height="100%" viewBox="0 0 74 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M73.5552 36.7673C73.5552 56.7874 36.9998 99.0097 36.9998 99.0097C36.9998 99.0097 0.444336 56.7874 0.444336 36.7673C0.444336 16.7473 16.8108 0.517822 36.9998 0.517822C57.1888 0.517822 73.5552 16.7473 73.5552 36.7673Z" fill="#555D65"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M28.7626 24.2089C28.3973 24.2089 28.1014 23.9602 28.1014 23.6538C28.1014 23.3478 28.3973 23.0991 28.7626 23.0991C29.1279 23.0991 29.4238 23.3478 29.4238 23.6538C29.4238 23.9602 29.1279 24.2089 28.7626 24.2089ZM49.9796 47.7394C49.9796 47.7382 49.9801 47.737 49.9801 47.7359L49.9794 47.732C49.9794 45.849 48.4322 44.3171 46.5314 44.3171C44.6302 44.3171 43.0835 45.849 43.0835 47.732C43.0629 48.1441 43.2174 48.8288 43.408 49.1792C43.4089 49.1811 43.4087 49.1825 43.4087 49.1825C43.4105 49.1859 43.4122 49.1871 43.4131 49.1887C43.5848 49.5504 44.0235 49.7077 44.391 49.5389C44.7552 49.3689 44.912 48.9344 44.7395 48.5714L44.7389 48.5706C44.6259 48.347 44.5419 47.9691 44.5521 47.7235C44.5521 46.6493 45.4402 45.7689 46.5314 45.7689C47.6202 45.7689 48.5061 46.6455 48.5104 47.7244C48.5104 47.7249 48.5106 47.7253 48.5106 47.7253V47.7303V47.732L48.5104 47.7325C48.5633 49.6456 47.1393 51.492 45.2658 51.9378C44.8844 52.0408 44.496 52.0917 44.11 52.0917C43.3554 52.0917 42.6089 51.8971 41.9351 51.5147C40.92 50.9387 40.1917 50.0063 39.8825 48.8883C39.8825 48.8883 39.8823 48.8879 39.8821 48.8873C39.8814 48.885 39.8807 48.8822 39.8795 48.8798C39.8795 48.8798 39.8788 48.8771 39.8783 48.8758V48.8755C39.1349 46.6711 39.5038 43.262 40.702 41.2654L40.7024 41.2645C44.052 35.425 42.9609 26.7214 38.27 21.8634C38.2677 21.8608 38.2673 21.8572 38.2648 21.8549C38.2626 21.8526 38.2596 21.8514 38.2575 21.8491C36.7678 19.9776 33.9171 18.699 31.8737 18.6484C31.8718 18.6484 31.0685 18.6472 31.0665 18.6472L31.0669 18.6484H24.0176L25.1996 20.0235V34.9549L24.3439 35.8031H29.5315L28.7631 35.0409V31.0342C28.7631 31.0342 33.0188 31.893 33.0188 22.8858C33.5313 22.8858 35.3311 26.9483 33.2095 32.192C31.5144 36.1252 31.0658 42.0306 32.2806 45.8124C32.2819 45.8162 32.2809 45.8205 32.2819 45.8244C32.2828 45.8278 32.2854 45.8304 32.2862 45.8342C33.0566 49.6634 36.7874 53.575 40.6022 54.554C40.6043 54.5545 40.6052 54.5558 40.6052 54.5558C40.6088 54.5569 40.6103 54.5562 40.6103 54.5562C42.4497 55.1277 44.4018 54.9555 46.1087 54.0702C47.8151 53.1857 49.0725 51.6948 49.6482 49.872C49.8415 49.3427 50.001 48.3105 49.9796 47.7394Z" fill="white"/>
      </svg>`;
          let svgNode = this.createSVGElementFromSVGString(svgString);
          this.markers[i].content = svgNode;

          this.markers[i].content.addEventListener("mouseenter", (e) => {
            const firstPath = svgNode.querySelector("path"); // Select the first path
            firstPath.setAttribute("fill", "#FF3235"); // Change to desired color on hover
          });
          // Add mouseout event to detect when the hover ends
          this.markers[i].content.addEventListener("mouseleave", (e) => {
            const firstPath = svgNode.querySelector("path"); // Select the first path
            firstPath.setAttribute("fill", "#555D65"); // Change to desired color on hover
            // e.target.content = svgNodeHovered;
            // You can revert any hover effects here
          });
        }
      }
    },
    dehighlightAllMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        let newContent = this.markers[i].content;
        newContent.style.width = "30px";
        this.markers[i].content = newContent;
        this.markers[i].zIndex = 0;
        // Add mouseover event to detect hover
      }
    },
    clearSingleMarker(index) {
      this.markers[index].setMap(null);
      this.markers.splice(index, 1);
    },
    clearAllMarkers() {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    },
    loadMarkers(markers) {
      this.escapeStreetView();
      this.clearAllMarkers();
      markers.forEach((marker) => {
        let position = {
          lat: Number(marker.mapCoordsLatitude),
          lng: Number(marker.mapCoordsLongitude),
        };
        this.addMarker(position);
      });
      this.zoomToFitAllMarkers();
    },
    goToPoint(position) {
      consoe.log("GOING TO POINT");
      const offsetLatLng = offsetCenter(new google.maps.LatLng(position.lat, position.lng), 400, this.map);
      this.map.setCenter(offsetLatLng);
      // this.map.setCenter({ lat: position.lat, lng: position.lng });
      this.map.setZoom(position.zoom);
    },
    offsetCenter(latlng, offsetX, map) {
      // Create a dummy overlay to get access to the map's projection
      const overlay = new google.maps.OverlayView();
      overlay.onAdd = function () {
        // Access the map's projection
        const projection = this.getProjection();

        // Convert the LatLng position to a point in the map's pixel space
        const point = projection.fromLatLngToDivPixel(latlng);

        // Apply the offset in pixels and divide by the zoom scale
        const offsetPoint = new google.maps.Point(point.x + offsetX, point.y);

        // Convert the point back to LatLng coordinates
        const newLatlng = projection.fromDivPixelToLatLng(offsetPoint);

        // Pan the map to the new LatLng position
        map.panTo(newLatlng);
      };

      // Attach the overlay to the map
      overlay.setMap(map);
    },
    zoomToFitAllMarkers() {
      const newBoundary = new google.maps.LatLngBounds();

      this.markers.forEach((marker) => {
        var position = marker.position;
        newBoundary.extend(position);
      });

      this.map.fitBounds(newBoundary);
    },
    createSVGElementFromSVGString(svgString) {
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgString, "image/svg+xml");
      const svgElement = svgDocument.documentElement;

      // Create a new SVG element from the parsed SVG string
      const svgNode = document.createElementNS("http://www.w3.org/2000/svg", "svg");

      // Copy attributes from the parsed SVG element to the new SVG element
      for (const attribute of svgElement.attributes) {
        svgNode.setAttribute(attribute.name, attribute.value);
      }

      // Copy child elements from the parsed SVG element to the new SVG element
      for (const childNode of svgElement.childNodes) {
        const clonedNode = childNode.cloneNode(true);
        svgNode.appendChild(clonedNode);
      }

      return svgNode;
    },
    addStreetViewPanorama(panoPosition) {
      // Define the position (LatLng object)
      var position = new google.maps.LatLng(panoPosition.lat, panoPosition.lng);

      // Create a Street View panorama element
      var streetViewElement = document.createElement("div");
      streetViewElement.id = "street-view";
      streetViewElement.style.height = "100%";
      streetViewElement.style.width = "100%";

      // Append the Street View panorama element to the body (or another container)
      this.$refs.map.appendChild(streetViewElement);

      // Create a Street View panorama object
      var panorama = new google.maps.StreetViewPanorama(streetViewElement, {
        position: position,
        pov: {
          heading: 34,
          pitch: 10,
        },
        showCloseButton: true,
      });

      this.map.setStreetView(panorama);
    },
    escapeStreetView() {
      if (document.getElementById("street-view") == undefined) {
        return;
      }
      document.getElementById("street-view").remove();
    },
    determineCountry(position) {
      const lat = position.lat;
      const lng = position.lng;

      // Initialize the Geocoder
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // Loop through address components to find country
            let country = null;
            results[0].address_components.forEach((component) => {
              if (component.types.includes("country")) {
                country = component.long_name; // Get country name
              }
            });

            // Determine the unit based on the country
            let unit = country === "United States" || country === "USA" ? "imperial" : "metric";

            // Emit the event with the correct unit
            EventBus.$emit("update_unit_system", {
              unit: unit,
            });
          }
        } else {
          console.error("Geocoder failed due to:", status);
        }
      });
    },
  },
};
</script>
<style scoped>
@media (max-width: 1024px) {
}
</style>
